import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import highlightBrand from 'helpers/highlightBrand';
import { getLanguage } from 'translation';

const Background = styled('section')(({ theme }) => ({
  backgroundColor: theme.palette.backgroundNeutral.main
}));

const AboutWrapper = styled('div')(({ theme, padding }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: 1030,
  paddingBottom: 40,
  paddingTop: 80,
  margin: '0 auto',
  ...(padding ? { padding: padding } : {}),
  [theme.breakpoints.down('lg')]: {
    padding: '50px 50px 24px',
    maxWidth: '100%'
  },
  [theme.breakpoints.down('md')]: {
    padding: '30px 30px 16px',
    ...(padding ? { padding: 0 } : {})
  },
  [theme.breakpoints.down('sm')]: {
    padding: '20px 20px 12px',
    ...(padding ? { padding: 0 } : {})
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 30,
  color: theme.palette.textPrimary.main,
  [theme.breakpoints.down('md')]: {
    fontSize: 39,
    lineHeight: '45px',
    marginBottom: 20
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    lineHeight: '36.4px'
  }
}));

const Description = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 400,
  marginBottom: 30,
  lineHeight: '31.2px',
  color: theme.palette.textPrimary.main,
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
    lineHeight: '23.4px',
    marginBottom: 20
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '27px'
  }
}));

const About = ({ texts, padding }) => {
  const lang = getLanguage();

  return (
    <Background>
      <AboutWrapper padding={padding}>
        <Title variant="h2">
          {highlightBrand(texts?.about_field1?.[lang])}
        </Title>
        <Description>{texts?.about_field2?.[lang]}</Description>
      </AboutWrapper>
    </Background>
  );
};

export default About;
